import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { DataShareService } from '@bo-client/shared/services/data-share.service';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  private numRequests = 0;
  private numAnswers = 0;
  private timeOut = false;

  // Use to avoid spinner by loading multiple images
  private images: string[] = ['.svg', '.png'];

  constructor(public dataShareService: DataShareService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.numRequests++;
    if (this.numRequests === 1) {
      setTimeout(() => {
        this.timeOut = true;
      }, 20);
    }
    this.dataShareService.setIsLoading(true);
    return next.handle(req).pipe(
      finalize(() => {
        this.numAnswers++;
        if (this.numRequests === this.numAnswers) {
          if (this.timeOut) {
            this.numRequests = 0;
            this.numAnswers = 0;
            this.timeOut = false;
            this.dataShareService.setIsLoading(false);
          } else {
            setTimeout(() => {
              this.timeOut = false;
              this.dataShareService.setIsLoading(false);
            }, 1000);
          }
        }
      })
    );
  }
}
